// extracted by mini-css-extract-plugin
export var extraMargin = "pageHeader-module--extraMargin--7494e";
export var pageHeader = "pageHeader-module--pageHeader--d6b3e";
export var pageHeaderRightSection = "pageHeader-module--pageHeader-right-section--cca95";
export var pageHeaderSubtitle = "pageHeader-module--pageHeader-subtitle--3bcdf";
export var pageHeaderTitle = "pageHeader-module--pageHeader-title--b9b61";